<template>
    <div class="">
		<button @click="openInput()" type="button" name="button" class="btn btn--blue-no-border full" :class="{error:error, 'load': isSend && !file.finish}" v-if="!file.finish">
			<span class="i i-upload mr8"></span>
			<span>{{btnText}}</span>
		</button>
		<button type="button" name="button" class="btn btn--blue-no-border full" v-else>
			<span class="i i-upload mr8"></span>
			<span class="file-name" :style="maxWidth">{{file.name}}</span>
			<span class="i i-close2" @click="deleteFile"></span>
		</button>

        <input v-if="!isSend" :accept="acceptType" style="display: none;" ref="fileInput" @change="onFileChange" type="file">
    </div>
</template>

<script>
    export default {
        name: "FileUpload",
        props: {
            acceptType: {default: ''},
            value: {default: function () {
                    return {}
            }},
            maxFilesSize: {default: 10*1024*1024},
            hint: {default: 'Максимальный вес — 10Мб'},
            btnText: {default: 'Загрузить файл'},
            fieldName: {default: 'file'},
            operation: {default: ''},
            error: {default: false},
            actionDelete: {type: String,required: true},
            actionSend: {type: String,required: true},
			maxWidth: {
				default: function(){
					return ''
				}
			}
        },
        data: function () {
            return {
                file: {},
                fileInput: false,
                errorSize: false,
                isSend: false,
                targetFile: false,
                targetFileType: false,
                ajax: false,
            }
        },
        mounted() {
            if(this.value.id){
                this.file = this.value
                this.file.finish = true;
            }

        },
        methods: {
            openInput: function() {
                if(!this.isSend) {
                    this.$refs.fileInput.click();
                    this.errorSize = false;
                }
            },

            onFileChange: function(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.$emit('change');
                this.createImage(files[0]);
            },

            getExt: function(name) {
                let parts;
                return ( parts = name.split(".") ).length > 1 ? parts.pop() : "";
            },

            createImage: function(file) {

                if(file.size > this.maxFilesSize) {
                    let self = this;
                    self.errorSize = true;
                    setTimeout(function () {
                        self.errorSize = false;
                    }, 3000);
                } else {
                    this.file = {
                        id: false,
                        name: file.name,
                        size: file.size,
                        path: false,
                        icon: false,
                        finish: false,
                        ext: this.getExt(file.name),
                        progress: 0,
                    };
                    this.fileUpload(this.currentIndex, file);
                }

            },

            deleteFile: function() {
                this.file = {};
                if(this.actionDelete){
                    this.$store.dispatch(this.actionDelete, {fieldName: this.fieldName});
                }
                this.$emit('input', {});
            },

            fileUpload: function (fileIndex, file) {
                let self = this;
                let formData = new FormData();
                formData.append(self.fieldName.toString(), file, file.name);
                if(!self.isSend) {
                    this.$emit('upload', true);
                    self.isSend = true;
                    this.$store.dispatch(this.actionSend, {form_data: formData,operation: this.operation}).then(function(f) {
                        if(f.error){
                            self.$emit('error', f.error);
                            self.file = {};
                            self.isSend = false;
                        } else {
                            self.isSend = false;
                            self.file = {
                                id: f.id,
                                name: self.file.name,
                                size: self.file.size,
                                path: f.path,
                                finish: true,
                                icon: f.icon,
                                ext: self.file.ext,
                            };
                            self.$emit('input', self.file);
                            self.$emit('upload', false);
                        }

                    });
                }
            }
        }
    }
</script>

<style>

</style>
